import { QRCodeSVG } from 'qrcode.react'

import LayoutService from 'components/LayoutService'
import Paragraph from 'components/Paragraph'
import Button from 'components/Button'
import Title from 'components/Title'
import Link from 'components/Link'

import Styled from './styled'

export default function QrcodeToLine({ categoryName, onBack = () => null }) {
  const textToLine = `สนใจบริการ ${categoryName}`
  const encode = encodeURI(textToLine)

  const url = `https://line.me/R/oaMessage/%40lji4221m/?${encode}`

  return (
    <LayoutService title={`ติดต่อรับบริการจากเจ้าหน้าที่`} needLogin={false} onBack={onBack}>
      <div className="container">
        <Styled>
          <div className="qrcode-container">
            <Title level={3}>กรุณาสแกน QR Code ด้านล่าง เพื่อรับบริการจากเจ้าหน้าที่</Title>
            <Paragraph className="text-subtitle">
              หากสแกนเสร็จแล้ว ทางทีมงานรบกวนให้ลูกค้ากด “ส่ง” ข้อความเพื่อรับบริการต่อ{'\n'}
              โดยไม่ต้องเลือกบริการใหม่
            </Paragraph>

            <QRCodeSVG value={url} size={300} includeMargin />

            <div className="detail-block">
              <Title level={3}>หรือ</Title>

              <div className="detail">
                <Link href={url} openNewTab>
                  <Button>คลิกที่นี่</Button>
                </Link>
              </div>
            </div>
          </div>

          <div className="button-prev">
            <Button type="ghost" onClick={onBack}>
              ย้อนกลับ
            </Button>
          </div>
        </Styled>
      </div>
    </LayoutService>
  )
}
